import {
  InvestcoreBankDetailPage,
  InvestcoreBankEditPage,
  InvestcoreBankListPage,
} from 'apps/investcore/components/banks/pages';
import {
  InvestmentProductDetailPage,
  InvestmentProductEditPage,
  InvestmentProductListPage,
} from 'apps/investcore/components/fund-products/pages';
import {
  InvestmentNotificationLogDetailPage,
  InvestmentNotificationLogListPage,
  InvestmentNotificationSendPage,
} from 'apps/investcore/components/notification-log/pages';
import { Navigate } from 'react-router-dom';
import {
  DistrictDetailPage,
  DistrictListPage,
} from '../components/districts/pages';
import {
  ETFProductDetailPage,
  ETFProductEditPage,
  ETFProfileEditPage,
  ETFProductListPage,
} from '../components/ETFProduct/pages';
import {
  InvestmentFundDistributorsDetailPage,
  InvestmentFundDistributorsListPage,
} from '../components/fund-distributors/pages';
import {
  FundManagersCreatePage,
  FundManagersDetailPage,
  FundManagersEditPage,
  FundManagersListPage,
} from '../components/fund-managers/pages';
import {
  MarketCalendarCreatePage,
  MarketCalendarDetailPage,
  MarketCalendarEditPage,
  MarketCalendarListPage,
} from '../components/market-calendar/pages';
import {
  MarketIndexCreatePage,
  MarketIndexDetailPage,
  MarketIndexEditPage,
  MarketIndexListPage,
} from '../components/market-indexes/pages';
import {
  HomeWidgetCreatePage,
  HomeWidgetDetailPage,
  HomeWidgetEditPage,
  HomeWidgetListPage,
} from '../components/home-widgets/pages';
import {
  StagPortfolioDetailPage,
  StagPortfolioFormPage,
  StagPortfolioListPage,
} from '../components/stag-portfolios/pages';
import {
  InvestmentThemeCategoryListPage,
  InvestmentThemeFormPage,
  InvestmentThemeListPage,
} from '../components/investment-themes/pages';
import {
  StockEventDetailPage,
  StockEventEditPage,
  StockEventListPage,
} from '../components/stock-events/pages';
import {
  ProvinceDetailPage,
  ProvinceEditPage,
  ProvinceListPage,
} from '../components/provinces/pages';
import {
  StaffAccountsCreatePage,
  StaffAccountsDetailPage,
  StaffAccountsEditPage,
  StaffAccountsListPage,
} from '../components/staff-accounts/pages';
import {
  StockProductDetailPage,
  StockProductEditPage,
  StockProductListPage,
} from '../components/StockProduct/pages';
import {
  StockFundamentalDetailPage,
  StockFundamentalListPage,
} from '../components/StockFundamental/pages';
import {
  ICBIndustryCreatePage,
  ICBIndustryDetailPage,
  ICBIndustryEditPage,
  ICBIndustryListPage,
  ICBSectorCreatePage,
  ICBSectorDetailPage,
  ICBSectorEditPage,
  ICBSectorListPage,
  ICBSubSectorCreatePage,
  ICBSubSectorDetailPage,
  ICBSubSectorEditPage,
  ICBSubSectorListPage,
  ICBSuperSectorCreatePage,
  ICBSuperSectorDetailPage,
  ICBSuperSectorEditPage,
  ICBSuperSectorListPage,
} from '../components/stock-icb/pages';
import { WardDetailPage, WardListPage } from '../components/wards/pages';
import { OpsMcpConfigPage } from '../components/ops-mcp/pages';

const investcoreRoutes = [
  { path: '/admin/provinces', element: <ProvinceListPage /> },
  { path: '/admin/provinces/:id', element: <ProvinceDetailPage /> },
  { path: '/admin/provinces/:id/edit', element: <ProvinceEditPage /> },
  { path: '/admin/districts', element: <DistrictListPage /> },
  { path: '/admin/districts/:id', element: <DistrictDetailPage /> },
  { path: '/admin/wards', element: <WardListPage /> },
  { path: '/admin/wards/:id', element: <WardDetailPage /> },
  { path: '/admin/banks', element: <InvestcoreBankListPage /> },
  { path: '/admin/banks/:id', element: <InvestcoreBankDetailPage /> },
  { path: '/admin/banks/:id/edit', element: <InvestcoreBankEditPage /> },
  {
    path: '/admin/products',
    element: <Navigate to="/admin/products/funds" />,
  },
  {
    path: '/admin/products/funds',
    element: <InvestmentProductListPage />,
  },
  {
    path: '/admin/products/funds/:id',
    element: <InvestmentProductDetailPage />,
  },
  {
    path: '/admin/products/funds/:id/edit',
    element: <InvestmentProductEditPage />,
  },
  { path: '/admin/products/etfs', element: <ETFProductListPage /> },
  {
    path: '/admin/products/etfs/:id',
    element: <ETFProductDetailPage />,
  },
  {
    path: '/admin/products/etfs/:id/edit',
    element: <ETFProductEditPage />,
  },
  {
    path: '/admin/products/etfs/:id/edit-profile',
    element: <ETFProfileEditPage />,
  },
  { path: '/admin/products/stocks', element: <StockProductListPage /> },
  {
    path: '/admin/products/stocks/:id',
    element: <StockProductDetailPage />,
  },
  {
    path: '/admin/products/stocks/:id/edit',
    element: <StockProductEditPage />,
  },
  {
    path: '/admin/stock-fundamentals',
    element: <StockFundamentalListPage />,
  },
  {
    path: '/admin/stock-fundamentals/:id',
    element: <StockFundamentalDetailPage />,
  },
  {
    path: '/admin/notification-logs',
    element: <InvestmentNotificationLogListPage />,
  },
  {
    path: '/admin/notification-logs/send',
    element: <InvestmentNotificationSendPage />,
  },
  {
    path: '/admin/notification-logs/:id',
    element: <InvestmentNotificationLogDetailPage />,
  },
  {
    path: '/admin/fund-distributors',
    element: <InvestmentFundDistributorsListPage />,
  },
  {
    path: '/admin/fund-distributors/:id',
    element: <InvestmentFundDistributorsDetailPage />,
  },
  {
    path: '/admin/fund-managers',
    element: <FundManagersListPage />,
  },
  {
    path: '/admin/fund-managers/create',
    element: <FundManagersCreatePage />,
  },
  {
    path: '/admin/fund-managers/:id',
    element: <FundManagersDetailPage />,
  },
  {
    path: '/admin/fund-managers/:id/edit',
    element: <FundManagersEditPage />,
  },
  {
    path: '/admin/market-calendar',
    element: <MarketCalendarListPage />,
  },
  {
    path: '/admin/market-calendar/create',
    element: <MarketCalendarCreatePage />,
  },
  {
    path: '/admin/market-calendar/:id',
    element: <MarketCalendarDetailPage />,
  },
  {
    path: '/admin/market-calendar/:id/edit',
    element: <MarketCalendarEditPage />,
  },
  {
    path: '/admin/market-index',
    element: <MarketIndexListPage />,
  },
  {
    path: '/admin/market-index/create',
    element: <MarketIndexCreatePage />,
  },
  {
    path: '/admin/market-index/:id',
    element: <MarketIndexDetailPage />,
  },
  {
    path: '/admin/market-index/:id/edit',
    element: <MarketIndexEditPage />,
  },
  {
    path: '/admin/home-widgets',
    element: <HomeWidgetListPage />,
  },
  {
    path: '/admin/home-widgets/create',
    element: <HomeWidgetCreatePage />,
  },
  {
    path: '/admin/home-widgets/:id',
    element: <HomeWidgetDetailPage />,
  },
  {
    path: '/admin/home-widgets/:id/edit',
    element: <HomeWidgetEditPage />,
  },
  {
    path: '/admin/stag-portfolios',
    element: <StagPortfolioListPage />,
  },
  {
    path: '/admin/stag-portfolios/create',
    element: <StagPortfolioFormPage />,
  },
  {
    path: '/admin/stag-portfolios/:id',
    element: <StagPortfolioDetailPage />,
  },
  {
    path: '/admin/stag-portfolios/:id/edit',
    element: <StagPortfolioFormPage />,
  },
  {
    path: '/admin/investment-themes',
    element: <InvestmentThemeListPage />,
  },
  {
    path: '/admin/investment-themes/create',
    element: <InvestmentThemeFormPage />,
  },
  {
    path: '/admin/investment-themes/:id/edit',
    element: <InvestmentThemeFormPage />,
  },
  { path: '/admin/ops-mcp', element: <OpsMcpConfigPage /> },
  {
    path: '/admin/investment-theme-categories',
    element: <InvestmentThemeCategoryListPage />,
  },
  {
    path: '/admin/stock-events',
    element: <StockEventListPage />,
  },
  {
    path: '/admin/stock-events/all',
    element: <StockEventListPage />,
  },
  {
    path: '/admin/stock-events/:id',
    element: <StockEventDetailPage />,
  },
  {
    path: '/admin/stock-events/:id/edit',
    element: <StockEventEditPage />,
  },
  {
    path: '/admin/staff-accounts',
    element: <StaffAccountsListPage />,
  },
  {
    path: '/admin/staff-accounts/create',
    element: <StaffAccountsCreatePage />,
  },
  {
    path: '/admin/staff-accounts/:id',
    element: <StaffAccountsDetailPage />,
  },
  {
    path: '/admin/staff-accounts/:id/edit',
    element: <StaffAccountsEditPage />,
  },
  // Wealth moved to /wealth/* — keep old URLs alive as redirects
  {
    path: '/admin/wealth/user-assignments',
    element: <Navigate to="/wealth/user-assignments" replace />,
  },
  {
    path: '/admin/wealth/user-assignments/create',
    element: <Navigate to="/wealth/user-assignments/create" replace />,
  },
  {
    path: '/admin/wealth/user-assignments/:id',
    element: <Navigate to="/wealth/user-assignments" replace />,
  },

  // ICB Classification
  { path: '/admin/stock-icb/industries', element: <ICBIndustryListPage /> },
  {
    path: '/admin/stock-icb/industries/create',
    element: <ICBIndustryCreatePage />,
  },
  {
    path: '/admin/stock-icb/industries/:id',
    element: <ICBIndustryDetailPage />,
  },
  {
    path: '/admin/stock-icb/industries/:id/edit',
    element: <ICBIndustryEditPage />,
  },
  {
    path: '/admin/stock-icb/supersectors',
    element: <ICBSuperSectorListPage />,
  },
  {
    path: '/admin/stock-icb/supersectors/create',
    element: <ICBSuperSectorCreatePage />,
  },
  {
    path: '/admin/stock-icb/supersectors/:id',
    element: <ICBSuperSectorDetailPage />,
  },
  {
    path: '/admin/stock-icb/supersectors/:id/edit',
    element: <ICBSuperSectorEditPage />,
  },
  { path: '/admin/stock-icb/sectors', element: <ICBSectorListPage /> },
  {
    path: '/admin/stock-icb/sectors/create',
    element: <ICBSectorCreatePage />,
  },
  {
    path: '/admin/stock-icb/sectors/:id',
    element: <ICBSectorDetailPage />,
  },
  {
    path: '/admin/stock-icb/sectors/:id/edit',
    element: <ICBSectorEditPage />,
  },
  { path: '/admin/stock-icb/subsectors', element: <ICBSubSectorListPage /> },
  {
    path: '/admin/stock-icb/subsectors/create',
    element: <ICBSubSectorCreatePage />,
  },
  {
    path: '/admin/stock-icb/subsectors/:id',
    element: <ICBSubSectorDetailPage />,
  },
  {
    path: '/admin/stock-icb/subsectors/:id/edit',
    element: <ICBSubSectorEditPage />,
  },
];

export default investcoreRoutes;
